<h1 class="route-title">{{ routeTitle$ | ngrxPush }}</h1>

<div class="portal-outlet-container">
    <ng-template *ngIf="componentPortalItem$ | ngrxPush as componentPortalItem" [cdkPortalOutlet]="componentPortalItem"></ng-template>
</div>

<ng-content select="[notificationsSlot]"></ng-content>
<ng-content select="[userButtonSlot]"></ng-content>
